var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_5338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 0H0V86H86V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 16.2C23.4001 23.9 28.5001 33 35.8001 33.3L37.0001 29.5C34.7001 28 32.7001 29 32.0001 25.3C31.1001 20.6 30.3001 22.3 27.0001 20.8H31.4001C31.3001 18.9 31.1001 18.6 30.3001 17.2C31.2001 16.6 31.5001 16.7 32.3001 15.8C30.4001 16.2 30.1001 16.2 28.0001 16.2ZM26.2001 14.5C25.8001 13.8 25.6001 13.3 25.8001 12.4C25.2001 13.2 25.2001 13.1 25.1001 14.5L24.5001 13.3L24.6001 15.3C23.1001 15.2 22.3001 15.5 21.9001 16.7C22.5001 16.3 23.1001 15.8 24.0001 16.2C23.3001 16.9 22.2001 17.2 21.2001 19.9C20.6001 21.4 20.4001 24.1 21.1001 25.5C22.1001 23.9 21.7001 23.7 23.1001 22.4C22.1001 24.9 21.6001 26.7 22.8001 29.5C23.6001 31.2 25.5001 33.2 27.0001 33.9C27.0001 32.7 27.1001 32.2 27.6001 31.2C27.5001 34.1 28.2001 35 30.8001 35.7C33.1001 36.3 34.0001 36.4 34.9001 34.9C36.5001 32.4 33.5001 35 28.7001 30.6C24.7001 26.9 24.1001 20.1 27.0001 16C28.5001 13.8 30.0001 13.1 33.1001 12.1C31.8001 11.2 30.4001 11.1 29.1001 12C27.6001 13.1 27.1001 14.3 26.2001 14.5ZM40.0001 19.8C41.5001 19.6 41.7001 19.3 43.5001 19.5C38.2001 19.4 39.5001 27.4 37.4001 32.6C36.6001 34.7 35.9001 34.9 34.3001 36.1C38.8001 36.4 40.8001 35 42.6001 31C43.7001 28.5 45.3001 23.1 45.3001 20.3C45.5001 25.9 44.0001 29.5 42.1001 33.9C44.5001 33 47.4001 28.8 48.0001 25.9C47.4001 26.1 46.9001 26.3 46.2001 26.4C47.7001 25.1 48.8001 24.8 48.5001 21.2C48.3001 19.5 47.7001 16.3 47.0001 15C45.8001 12.9 43.8001 12.3 42.3001 14.4C41.4001 15.7 40.3001 18 40.0001 19.8Z",
    fill: "#81061A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 54.6L16.2002 53.1C15.4002 52.5 15.1002 52.2 14.5002 51.7C10.1002 47.8 12.5002 46.4 17.0002 47.8C22.7002 49.7 26.3002 52.9 33.3002 54.4C46.4002 57.2 65.8002 53.8 51.1002 45.7C48.3002 44.2 46.4002 43.2 45.0002 41C42.8002 37.6 43.1002 31.7 46.8002 33.4C47.1002 33.5 48.0002 34.4 48.3002 34.7C57.5002 43.5 78.3002 42.2 77.0002 78.9C76.0002 78.1 75.9002 77.4 75.2002 76.3C73.3002 73.4 70.7002 70.6 67.5002 68.6C56.0002 61.6 44.6002 66.6 32.5002 62.2C26.4002 60 22.8002 57.6 18.0002 54.6Z",
    fill: "#81061A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_5338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinFriendly);
export default __webpack_public_path__ + "static/media/skinFriendly.78725e6df1cd6e8ff0dae6d34ac32755.svg";
export { ForwardRef as ReactComponent };